// src/redux/orgSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCourseId: null,
  activeSelectedCourseIndex : null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setActiveCourseId(state, action) {
      state.activeCourseId = action.payload;
    },
    setActiveSelectedCourseIndex(state, action) {
        state.activeSelectedCourseIndex = action.payload;
      }
  }
});

export const { setActiveCourseId, setActiveSelectedCourseIndex } = dashboardSlice.actions;
export default dashboardSlice.reducer;